export default function BrandTitle({ text }) {
  const parts = text.split("TiiRADA");
  if (parts.length === 1) return text;
  return (
    <span>
      {parts.map((part, i) => (
        <span key={i}>
          {part}
          {i < parts.length - 1 && <span className="brand-nocaps">TiiRADA</span>}
        </span>
      ))}
    </span>
  );
}
